import { render, staticRenderFns } from "./VSPR.vue?vue&type=template&id=4d79536f&"
import script from "./VSPR.vue?vue&type=script&lang=js&"
export * from "./VSPR.vue?vue&type=script&lang=js&"
import style0 from "./VSPR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports